<template>
  <section v-if="wp.related && wp.related.length" class="layout-section -bg-primary">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Articles en lien avec ce projet</h2>
    </div>

    <section v-scroll:reveal class="slider" :style="{ '--height': `${sizes.height}px` }">
      <TransitionGroup :name="transitionName" tag="div" class="card-article">
        <DemoGridArticlesSingle
          v-for="publication in publications"
          :key="publication.id"
          ref="card"
          route-name="news-single"
          slug-key="newsSlug"
          :slug="publication.slug"
          :type="publication.type"
          class="slider__item"
          :style="{ '--width': `${sizes.width}px`, '--height': `${sizes.height}px` }"
        />
      </TransitionGroup>

      <div class="slider__controls">
        <button
          v-if="hasPrevPublication"
          class="slider__button -prev"
          aria-label="Afficher prochaine nouvelle"
          @click="onClickPrev"
        >
          <SvgIcon id="arrow" class="-reverse" />
        </button>

        <button
          v-if="hasNextPublication"
          class="slider__button -next"
          aria-label="Afficher prochaine nouvelle"
          @click="onClickNext"
        >
          <SvgIcon id="arrow" />
        </button>
      </div>
    </section>

    <div v-scroll:reveal class="layout-section__controls">
      <RouterLink :to="{ name: 'publication-index' }" class="button layout-section__cta">
        Voir toutes les publications
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </div>
  </section>
</template>

<script>
import DemoGridArticlesSingle from '../../component-demo/partials/DemoGridArticlesSingle.vue'

export default {
  name: 'ProjectsSingleMore',
  components: { DemoGridArticlesSingle },
  inject: ['wp'],
  data() {
    return {
      startIndex: 0,
      transitionName: 'slider__item-next',
      sizes: {
        width: 0,
        height: 'auto'
      }
    }
  },
  computed: {
    itemCount() {
      const phoneCount = this.$device.phoneH ? 2 : 1
      return Math.min(this.allPublications.length, this.$device.laptop ? 3 : phoneCount)
    },
    allPublications() {
      if (!this.wp.related || !this.wp.related.length) return []
      return this.wp.related.map(id => this.$wp.publicationsById[id]).filter(Boolean)
    },
    publications() {
      return this.allPublications.slice(this.startIndex, this.startIndex + this.itemCount)
    },
    hasNextPublication() {
      return this.startIndex + this.itemCount < this.allPublications.length
    },
    hasPrevPublication() {
      return this.startIndex > 0
    }
  },
  watch: {
    publications: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (!this.$refs.card || !this.$refs.card.length) return
          const [firstCard, secondCard] = this.$refs.card
          const card = secondCard || firstCard
          this.sizes.width = card.$el.offsetWidth
          this.sizes.height = card.$el.offsetHeight || 'auto'
        })
      }
    }
  },
  methods: {
    onClickNext() {
      if (this.hasNextPublication) {
        this.transitionName = 'slider__item-next'
        this.startIndex++
      }
    },
    onClickPrev() {
      if (this.hasPrevPublication) {
        this.transitionName = 'slider__item-prev'
        this.startIndex--
      }
    }
  }
}
</script>
